export default function InitHomepageModules() {
    const targets = [...document.querySelectorAll('.ng-story-photo, .ng-story-copy')];
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!targets.length || preference.matches) return;

    // Animate visible content on arrival instead of hiding it until JavaScript runs.
    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const element = entry.target;
            observer.unobserve(element);
            if (preference.matches || element.contains(document.activeElement) || element.closest('.ng-story') === document.activeElement) continue;
            element.animate([
                { opacity: .15, transform: 'translateY(16px)' },
                { opacity: 1, transform: 'translateY(0)' },
            ], { duration: 650, easing: 'cubic-bezier(.22, 1, .36, 1)' });
        }
    }, { rootMargin: '0px 0px 32px 0px', threshold: 0 });

    const stopMotion = () => {
        observer.disconnect();
        observer.takeRecords();
        for (const element of targets) {
            for (const animation of element.getAnimations()) animation.cancel();
        }
    };
    for (const element of targets) observer.observe(element);
    preference.addEventListener('change', stopMotion, { once: true });
    window.addEventListener('beforeprint', stopMotion, { once: true });
    for (const story of document.querySelectorAll('.ng-story')) {
        story.addEventListener('focusin', () => {
            for (const element of story.querySelectorAll('.ng-story-photo, .ng-story-copy')) {
                observer.unobserve(element);
                for (const animation of element.getAnimations()) animation.cancel();
            }
        });
    }
}
